import { useEffect, useRef, useState } from "react";

const DURATION_MS = 1800;
const NBSP = "\u00a0";
const format = (n) => Math.round(n).toLocaleString("fr-FR").replace(/\s/g, NBSP);
const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

export const CountUp = ({ value, prefix = "+", testId }) => {
  const ref = useRef(null);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setDisplay(value);
      return;
    }
    let frame;
    const animate = () => {
      const start = performance.now();
      const step = (now) => {
        const t = Math.min((now - start) / DURATION_MS, 1);
        setDisplay(value * easeOutCubic(t));
        if (t < 1) frame = requestAnimationFrame(step);
      };
      frame = requestAnimationFrame(step);
    };
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        animate();
      }
    }, { threshold: 0.4 });
    observer.observe(el);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [value]);

  return (
    <span ref={ref} className="tabular-nums" data-testid={testId}>
      {prefix}{format(display)}
    </span>
  );
};
